<template>
  <v-container>
    <v-form @submit.prevent="submit" ref="form">
      <v-row>
        <v-col cols="12" md="8">
          <v-text-field
            label="구역명"
            v-model="area.name"
            :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            type="number"
            label="반경"
            v-model="area.rad"
            suffix="m"
            :rules="[rules.moreThanZero]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" v-if="area.address">
          <v-text-field label="주소" v-model="area.address" readonly hide-details></v-text-field>
        </v-col>
        <v-col cols="12">
          <google-map v-slot="{ google, map }" class="fill-height" style="height: 500px" ref="gmap" @click="setPos">
            <google-map-control :google="google" :map="map">
              <v-card class="pa-2">
                <google-map-autocomplete :google="google" :map="map" @change="onAutocomplete"></google-map-autocomplete>
              </v-card>
            </google-map-control>
            <google-map-marker v-if="marker" :marker-options="markerOptions" :google="google" :map="map" ref="marker"></google-map-marker>
            <google-map-circle v-if="marker" :center="area.pos" :radius="area.rad" :google="google" :map="map" ref="circle"></google-map-circle>
          </google-map>
        </v-col>
      </v-row>

      <v-btn type="submit" color="success">{{ submitText }}</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import { getArea, updateArea, createArea } from '@/api'

export default {
  props: {
    new: {
      type: Boolean,
      default: false
    }
  },
  async beforeRouteEnter (to, from, next) {
    const _id = to.params._id

    if (!_id) return next()

    try {
      const area = await getArea(_id)
      next(vm => {
        Object.assign(vm.$data.area, area)
        vm.$data.marker = true
      })
    } catch (err) {
      console.error(err.message)
      next()
    }
  },
  data () {
    return {
      marker: false,
      area: {
        name: '',
        address: '',
        pos: {
          lat: 0,
          lng: 0
        },
        rad: 200
      },
      rules: {
        required: v => !!v || '필수 입력 사항입니다.',
        moreThanZero: v => v > 0 || '0 보다 큰 값을 입력하세요.'
      }
    }
  },
  watch: {
    'area.rad': function (val) {
      const rad = parseInt(val, 10) || 0
      this.$refs.circle.circle.setRadius(rad)
    }
  },
  computed: {
    submitText () {
      return this.new ? '만들기' : '적용'
    },
    markerOptions () {
      return {
        position: this.area.pos
      }
    }
  },
  methods: {
    onAutocomplete ({ location, address }) {
      this.setPos(location)
      this.area.address = address
    },
    setPos (location) {
      this.marker = true
      const { lat, lng } = location.toJSON()
      this.area.pos.lat = lat
      this.area.pos.lng = lng
      this.$nextTick(() => {
        const circle = this.$refs.circle.circle
        const marker = this.$refs.marker.marker
        // const map = this.$refs.gmap.map

        circle.setCenter(location)
        marker.setPosition(location)
        // map.panTo(location)
      })
    },
    async submit () {
      if (this.loading) return
      if (!this.marker) return alert('구역이 지정되지 않았습니다.')
      if (!this.$refs.form.validate()) return alert('입력 폼을 확인하세요.')
      this.loading = true
      try {
        const $promise = this.area.hasOwnProperty('_id') ? updateArea(this.area._id, this.area) : createArea(this.area)
        await $promise
        alert('성공')
        this.$router.go(-1)
      } catch (err) {
        alert(err.message)
      }

      this.loading = false
    }
  }
}
</script>
